var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "data-balance-rechange" }, [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("merchant.account_balance")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "rechange-middle" },
      [
        _c("div", { staticClass: "custom-breadcrumbs" }, [
          _c("i", {
            staticClass: "el-icon-arrow-left icon-back",
            on: {
              click: function ($event) {
                return _vm.onClickFistBread("Financial_Manage_Balance")
              },
            },
          }),
          _c(
            "span",
            {
              staticClass: "first-span",
              on: {
                click: function ($event) {
                  return _vm.onClickFistBread("Financial_Manage_Balance")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("data.recharge_record")))]
          ),
          _c("span", { staticStyle: { margin: "0 12px" } }, [_vm._v(" /")]),
          _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.$t("data.step")) +
                " " +
                _vm._s(_vm.activeStep === 1 ? 1 : 2)
            ),
          ]),
        ]),
        _vm.activeStep === 1 && _vm.$store.getters.isAllCountry
          ? _c(
              "el-form",
              {
                staticClass: "recharge-currency-form",
                attrs: {
                  "label-position": "left",
                  model: _vm.rechargeForm,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("data.top_up_currency") + ":",
                      prop: "currency",
                      rules: [
                        {
                          required: true,
                          message: _vm.$t("data.top_up_currency"),
                          trigger: "change",
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "recharge-currency-select",
                        attrs: {
                          size: "small",
                          placeholder: _vm.$t("data.top_up_currency"),
                          clearable: "",
                        },
                        on: { change: _vm.onRechargeCurrencyChange },
                        model: {
                          value: _vm.rechargeForm.currency,
                          callback: function ($$v) {
                            _vm.$set(_vm.rechargeForm, "currency", $$v)
                          },
                          expression: "rechargeForm.currency",
                        },
                      },
                      _vm._l(
                        _vm.$store.state.page.countryArr,
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.currency,
                              value: item.currency,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.activeStep === 1 &&
        (!_vm.$store.getters.isAllCountry || _vm.rechargeForm.currency)
          ? _c("div", { staticClass: "select-bank-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("data.select_bank")) + " "),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "select-bank" },
          [
            _vm.activeStep === 1 &&
            (!_vm.$store.getters.isAllCountry || _vm.rechargeForm.currency)
              ? _c(
                  "div",
                  { staticClass: "bank-container" },
                  _vm._l(_vm.bankList, function (item, index) {
                    return _c(
                      "span",
                      {
                        key: index,
                        class: {
                          bank: true,
                          active: _vm.activeIndex === index,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickBank(index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.bank))]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.activeStep === 2
              ? _c("div", { staticClass: "tip-enter" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("data.enter_top_up_amount")) + " "
                  ),
                ])
              : _vm._e(),
            _c(
              "el-form",
              {
                ref: "rechargeForm",
                attrs: {
                  "label-position": "left",
                  model: _vm.rechargeForm,
                  "status-icon": "",
                  "label-width": "150px",
                },
              },
              [
                _vm.activeStep === 2
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("data.payment_type") + ":",
                          prop: "top_up_type",
                          rules: [
                            {
                              required: true,
                              message: "Payment Type cannot be empty",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _vm.showBankInfo.bank === "Chillpay"
                          ? _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.rechargeForm.top_up_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rechargeForm,
                                      "top_up_type",
                                      $$v
                                    )
                                  },
                                  expression: "rechargeForm.top_up_type",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 4 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("data.thai_qr_payment"))
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.rechargeForm.top_up_type,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rechargeForm,
                                      "top_up_type",
                                      $$v
                                    )
                                  },
                                  expression: "rechargeForm.top_up_type",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("data.online_banking"))),
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v(_vm._s(_vm.$t("data.offline_check"))),
                                ]),
                                _c("el-radio", { attrs: { label: 3 } }, [
                                  _vm._v(_vm._s(_vm.$t("data.offline_cash"))),
                                ]),
                              ],
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.activeStep === 2
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("data.payment_account") + ":",
                          prop: "bank_no",
                          rules: [
                            {
                              required: true,
                              message: "Payment Account cannot be empty",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "input-item",
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("data.payment_account"),
                              clearable: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                            model: {
                              value: _vm.rechargeForm.bank_no,
                              callback: function ($$v) {
                                _vm.$set(_vm.rechargeForm, "bank_no", $$v)
                              },
                              expression: "rechargeForm.bank_no",
                            },
                          },
                          _vm._l(_vm.accountList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label:
                                  item.settlement_bank +
                                  "-" +
                                  item.settlement_bank_account_num,
                                value: item.bank_no,
                              },
                            })
                          }),
                          1
                        ),
                        _c("br"),
                        _vm.accountList.length === 0
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#71110e",
                                  "font-size": "12px",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("tips.not_bank_account")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.accountList.length === 0
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3855f1",
                                  cursor: "pointer",
                                  "font-size": "12px",
                                  "padding-left": "10px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      name: "Financial_Manage_Setting",
                                    })
                                  },
                                },
                              },
                              [_vm._v("Go to Add")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.activeStep === 2
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.showBankInfo.bank !== "Chillpay"
                              ? _vm.$t("components.amount")
                              : _vm.$t("data.top_up_amount") + ":",
                          prop: "amount",
                          rules: [
                            {
                              required: true,
                              message: "Amount cannot be empty",
                              trigger: "blur",
                            },
                            { validator: _vm.checkAmount, trigger: "blur" },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "input-item",
                            attrs: {
                              size: "small",
                              type: "text",
                              placeholder: "Enter amount",
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.rechargeForm.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.rechargeForm, "amount", $$v)
                              },
                              expression: "rechargeForm.amount",
                            },
                          },
                          [
                            _c("template", { slot: "prepend" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters.isAllCountry
                                    ? _vm.rechargeForm.currency
                                    : _vm.$store.getters.currency
                                ) + " "
                              ),
                            ]),
                          ],
                          2
                        ),
                        _vm.showBankInfo.bank === "Chillpay"
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#7A869E",
                                  "line-height": "1.5",
                                },
                              },
                              [
                                _vm._v(
                                  " ( " +
                                    _vm._s(
                                      _vm.$store.getters.isMX
                                        ? _vm.$t("tips.qr_tips")
                                        : _vm.$t("tips.thai_qr_tips")
                                    ) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.activeStep === 2
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("merchantAccount.money_source") + ":",
                          prop: "money_source",
                          rules: [
                            {
                              required: true,
                              message: "Source of Funds cannot be empty",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "input-item",
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t(
                                "merchantAccount.money_source"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.rechargeForm.money_source,
                              callback: function ($$v) {
                                _vm.$set(_vm.rechargeForm, "money_source", $$v)
                              },
                              expression: "rechargeForm.money_source",
                            },
                          },
                          _vm._l(_vm.fundsSourceMap, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                        _c("br"),
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.rechargeForm.money_source === 99,
                              expression: "rechargeForm.money_source === 99",
                            },
                          ],
                          staticClass: "input-item",
                          attrs: {
                            placeholder: _vm.$t("map.funds_source_99"),
                            type: "text",
                            size: "small",
                            autocomplete: "off",
                            clearable: "",
                          },
                          model: {
                            value: _vm.rechargeForm.money_source_defined,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rechargeForm,
                                "money_source_defined",
                                $$v
                              )
                            },
                            expression: "rechargeForm.money_source_defined",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    !_vm.$store.getters.isAllCountry ||
    (_vm.rechargeForm.currency && _vm.showBankInfo.id)
      ? _c(
          "div",
          { staticClass: "content" },
          [
            _c("p", { staticClass: "info" }, [
              _vm._v(_vm._s(_vm.$t("data.bank_details"))),
            ]),
            _c(
              "div",
              [
                _c("p", { staticClass: "tip" }, [
                  _vm._v(_vm._s(_vm.$t("data.recharge_tip"))),
                ]),
                _c(
                  "el-descriptions",
                  { attrs: { column: 1 } },
                  [
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          "label-class-name": "bank-label",
                          label: _vm.$t("merchant.account_name"),
                        },
                      },
                      [
                        _c("span", { staticClass: "bank-info" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("cryptoJSAesDecrypt")(
                                _vm.showBankInfo.bank_account_name
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          "label-class-name": "bank-label",
                          label: _vm.$t("merchant.account_bank"),
                        },
                      },
                      [
                        _c("span", { staticClass: "bank-info" }, [
                          _vm._v(_vm._s(_vm.showBankInfo.bank_full_name)),
                        ]),
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          "label-class-name": "bank-label",
                          label: _vm.$t("merchant.account_num"),
                        },
                      },
                      [
                        _c("span", { staticClass: "bank-info" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("cryptoJSAesDecrypt")(
                                _vm.showBankInfo.bank_account
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          "label-class-name": "bank-label",
                          label: _vm.$t("merchant.company_address"),
                        },
                      },
                      [
                        _vm.$store.getters.curCountry.country_code === "PH"
                          ? _c("span", { staticClass: "bank-info" }, [
                              _vm._v(
                                "Unit 905, One Global Place, 5th Avenue corner 25th Street, Bonifacio Global City, Fort Bonifacio, Taguig City"
                              ),
                            ])
                          : _c("span", { staticClass: "bank-info" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      {
                        attrs: {
                          "label-class-name": "bank-label",
                          label: _vm.$t("merchant.account_address"),
                        },
                      },
                      [
                        _c("span", { staticClass: "bank-info" }, [
                          _vm._v(_vm._s(_vm.showBankInfo.bank_address)),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.activeStep === 2
              ? [
                  _c("el-divider", { staticClass: "divider" }),
                  _c("p", { staticClass: "info" }, [
                    _c("span", { staticStyle: { color: "#71110e" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("data.upload_receipt"))),
                  ]),
                  _c(
                    "div",
                    [
                      _c("p", { staticClass: "tip" }, [
                        _vm._v(_vm._s(_vm.$t("tips.upload_receipt_tip"))),
                      ]),
                      _c(
                        "UploadFile",
                        _vm._g(
                          {
                            attrs: {
                              "accept-type":
                                ".jpg,.png,.jpeg,.webp,.pdf,.PDF,.JPG,.PNG,.JPEG,.WEBP",
                              "limit-num": 5,
                              list: _vm.urlList,
                              type: "recharge",
                            },
                            on: {
                              templateFileSuccess: _vm.templateFileSuccess,
                            },
                          },
                          _vm.$listeners
                        )
                      ),
                      _vm._l(_vm.urlList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item._uid,
                            staticStyle: { "margin-bottom": "10px" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "content-file",
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickFileName(
                                      item.relativePath
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.fileName))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  type: "danger",
                                  size: "mini",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickRemoveBtn(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("components.delete")))]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _c("el-divider", { staticClass: "divider" }),
                  _c("p", { staticClass: "info" }, [
                    _vm._v(_vm._s(_vm.$t("data.remark"))),
                  ]),
                  _c("el-input", {
                    staticStyle: {
                      width: "515px",
                      height: "133px",
                      "margin-bottom": "20px",
                    },
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      maxlength: "250",
                      placeholder: "Enter message or remarks",
                    },
                    model: {
                      value: _vm.rechargeForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.rechargeForm, "remark", $$v)
                      },
                      expression: "rechargeForm.remark",
                    },
                  }),
                ]
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _vm.activeStep === 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-footer",
                        attrs: {
                          type: "info",
                          disabled: _vm.submiting || !_vm.showBankInfo.id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.nextButton()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.next")))]
                    )
                  : _vm._e(),
                _vm.activeStep === 2
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-footer btn-defalt",
                        attrs: { disabled: _vm.submiting },
                        on: {
                          click: function ($event) {
                            _vm.activeStep = 1
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.previous")))]
                    )
                  : _vm._e(),
                _vm.activeStep === 2
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-footer",
                        attrs: { type: "info", disabled: _vm.submiting },
                        on: {
                          click: function ($event) {
                            return _vm.onClickSubmitBtn("form")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("components.submit")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("RechargeSuccessModal", {
              ref: "rechargeSuccessModal",
              on: { closeModal: _vm.closeModal },
            }),
            _c("RechargeSuccessModalThaiQR", {
              ref: "rechargeSuccessModalThaiQR",
              on: { closeModal: _vm.closeModal },
            }),
            _c(
              "el-dialog",
              {
                attrs: { visible: _vm.dialogImageVisible },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogImageVisible = $event
                  },
                },
              },
              [
                _c("img", {
                  attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
                }),
              ]
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }